/**
 * Root app component. Extracts the survey token from the URL and renders
 * the appropriate page.
 * @agentic members
 */

import { NpsSurveyPage } from "./NpsSurveyPage";
import { SurveyPage } from "./SurveyPage";
import { ScreenerPage } from "./screener/ScreenerPage";

/**
 * Extracts the token from a /s/<token>, /nps/<token>, or /screener/<token> URL path.
 */
const getRoute = ():
  | { kind: "phq"; token: string }
  | { kind: "nps"; token: string }
  | { kind: "screener"; token: string }
  | null => {
  const screenerMatch = window.location.pathname.match(/^\/screener\/(.+)$/);
  if (screenerMatch?.[1]) {
    return { kind: "screener", token: screenerMatch[1] };
  }
  const npsMatch = window.location.pathname.match(/^\/nps\/(.+)$/);
  if (npsMatch?.[1]) {
    return { kind: "nps", token: npsMatch[1] };
  }
  const surveyMatch = window.location.pathname.match(/^\/s\/(.+)$/);
  if (surveyMatch?.[1]) {
    return { kind: "phq", token: surveyMatch[1] };
  }
  return null;
};

export const App = () => {
  const route = getRoute();

  if (!route) {
    return <SurveyPage token={null} />;
  }

  if (route.kind === "nps") {
    return <NpsSurveyPage token={route.token} />;
  }

  if (route.kind === "screener") {
    return <ScreenerPage token={route.token} />;
  }

  return <SurveyPage token={route.token} />;
};
